// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_dp-0";
export var animationContainer = "_dp-1";
export var modalContent = "_dp-2";
export var orderName = "_dp-3";
export var refundOption = "_dp-4";
export var refundOptionsContainer = "_dp-5";